import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _obj;
import EmberObject from "@ember/object";
import discourseComputed from "discourse-common/utils/decorators";
export default EmberObject.extend((_obj = {
  isLastVisited() {
    return this.lastVisitedTopic === this.topic;
  }
}, (_applyDecoratedDescriptor(_obj, "isLastVisited", [discourseComputed], Object.getOwnPropertyDescriptor(_obj, "isLastVisited"), _obj)), _obj));